<script setup lang="ts">
import InfinityIcon from "~/components/icons/simple/InfinityIcon.vue";
import BadgePlusIcon from "~/components/icons/simple/BadgePlusIcon.vue";

</script>

<template>
  <div class="partial-limited-icon">
    <InfinityIcon />
    <BadgePlusIcon />
  </div>
</template>

<style scoped lang="scss">
@use "assets/styles/global/variables" as v;

.partial-limited-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  @media screen and (min-width: v.$desktop) {
    flex-direction: row;
    gap: 5px;
  }
}
</style>